// @flow

import _ from 'lodash';

import type {
  GetNotificationsState,
  GetNotificationsAction
} from 'stores/flow-type/dashboard/notification.type';

import {
  GET_NOTIFICATIONS_REQUEST,
  GET_NOTIFICATIONS_SUCCESS,
  GET_NOTIFICATIONS_FAILURE,
  DISMISS_NOTIFICATION_REQUEST
} from 'stores/flow-type/dashboard/notification.type';

import { dismissNotification } from 'src/helpers/dashboard-helper';

const initialState: GetNotificationsState = {
  loading: false,
  success: false,
  error: undefined,
  list: [],
  topList: []
};

const NotificationsReducers = (
  state: GetNotificationsState = initialState,
  action: GetNotificationsAction
) => {
  switch (action.type) {
    case GET_NOTIFICATIONS_REQUEST:
      return { ...state, loading: true };
    case GET_NOTIFICATIONS_SUCCESS: {
      const { data } = action.payload;

      const topList = _.filter(data, notification => {
        return notification.level === 1;
      });

      const list = _.filter(data, notification => {
        return notification.level !== 1;
      });

      return { ...state, loading: false, error: undefined, topList, list };
    }
    case GET_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      };
    case DISMISS_NOTIFICATION_REQUEST: {
      const { notificationId, shop } = action.payload;

      // Save dismissed notification to localstorage
      dismissNotification(notificationId, shop);

      // Remove notification from list of notifications
      const updatedNotifications = _.filter(state.list, notification => {
        return notification.id !== notificationId;
      });

      // Remove notification from list of top notifications
      const updatedTopNotifications = _.filter(state.topList, notification => {
        return notification.id !== notificationId;
      });

      return { ...state, list: updatedNotifications, topList: updatedTopNotifications };
    }
    default:
      return state;
  }
};

export default NotificationsReducers;
